<template>
    <v-container class="fill-height" style="display: block;" fluid>

        <div class="no-license-text" v-if="!hasLicense">
            <p>
                This feature is not enabled. Please contact <a href="mailto:support@telsasoft.com" style="color: #c42111;">support</a> to enable it. 
            </p>
        </div>

        <div class="no-license-text" v-else-if="!isCustomerAdmin">
            <p>
                You must be an <b>admin</b> user to use this feature.
            </p>
        </div>

        <v-window v-model="windowPage" style="width: 100%;" touchless v-else>
            <v-window-item :key="0">
                <div id="ag-grid-container">
                    <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                        @row-double-clicked="doubleClickHandler"
                        :gridOptions="gridOptions"
                        :groupHeaders="true"
                        :rowHeight="40">
                    </ag-grid-vue>
                </div>
                <v-btn color="#c42111" class="mt-3" @click="addNewNetworkDiscoveryRequest" :disabled="lockSave">New</v-btn>
            </v-window-item>

            <v-window-item :key="1">
                <network-discovery-results :networkDiscoveryRequest="selectedNetworkDiscovery" :existingDevices="existingDevices" :pmSnmpOptions="pmSnmpOptions" :refresh="refreshResults" @back="windowPage = 0;" @addDevicesClick="addDevicesClick" />
            </v-window-item>
        </v-window>

        <v-dialog v-model="showNetworkDiscoveryEdit" max-width="80%" width="800px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? closeEditNetworkDiscoveryRequest() : null}">
            <network-discovery-edit :networkDiscoveryRequest="networkDiscoveryEdit" :pmSnmpOptions="pmSnmpOptions" @cancel="closeEditNetworkDiscoveryRequest" @save="saveNetworkDiscoveryRequest" v-if="showNetworkDiscoveryEdit" /> 
        </v-dialog>

        <v-dialog v-model="showAddDevices" max-width="80%" width="1600px" persistent :attach="$store.state.fullscreenElement" v-if="showAddDevices" @keydown="(k) => {k.key == 'Escape' ? cancelAddDevices() : null}">
            <network-discovery-add-devices :deviceType="addDeviceType" :devices="selectedAddDevices" :pmSnmpOptions="pmSnmpOptions" @save="addDevices" @cancel="cancelAddDevices()" v-if="showAddDevices"></network-discovery-add-devices>
        </v-dialog>

    </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import NetworkDiscoveryEdit from "@/components/NetworkDiscovery/NetworkDiscoveryEdit";
import NetworkDiscoveryResults from "@/components/NetworkDiscovery/NetworkDiscoveryResults";
import NetworkDiscoveryAddDevices from "@/components/NetworkDiscovery/NetworkDiscoveryAddDevices";
export default {
    name: 'NetworkDiscovery',
    props: [''],
    components: {
        'ag-grid-vue': AgGridVue,
        NetworkDiscoveryEdit,
        NetworkDiscoveryResults,
        NetworkDiscoveryAddDevices
    },
    data: () => ({
        windowPage: 0,
        existingDevices: null,
        pmSnmpOptions: [],
        networkDiscoveryRequests: [],
        lockSave: false,
        showNetworkDiscoveryEdit: false,
        networkDiscoveryEdit: null,
        showGrid: false,
        gridOptions: {},
        gridApi: null,
        selectedNetworkDiscovery: null,

        showAddDevices: false,
        selectedAddDevices: null,
        addDeviceType: null,
        refreshResults: 0,
    }),

    computed: {
        hasLicense: function() {
            return this.$store.state.batchConfig.webapp_network_discovery;
        },

        isCustomerAdmin: function() {
            return (this.$store.state.user.user_data.is_customer_admin);
        },
    },

    methods: {
        getExistingDevices: function() {
            let route = `${TELSA.apiHost}networkdiscovery/devices`;
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let results = response.body;
                Object.keys(results.pm_groups_dict).forEach(key => {
                    this.pmSnmpOptions.push({
                        'value': key,
                        'text': results.pm_groups_dict[key]
                    });
                });
                this.existingDevices = results;
                TELSA.loading(false);
            });
        },

        getNetworkDiscoveryRequestList: function() {
            this.showGrid = false;
            let route = `${TELSA.apiHost}networkdiscovery/list`;
            TELSA.loading(true);
            return this.$http.post(route, {args: {}}).then(response => {
                let results = response.body;
                this.networkDiscoveryRequests = results;
                this.buildAgGrid();
                TELSA.loading(false);
            });
        },

        addNewNetworkDiscoveryRequest: function() {
            this.networkDiscoveryEdit = {
                request_id: 0,
                network: "",
                scan_options: {
                    //maxHops: 1,
                    enablePing: true,
                    pingTimeoutSec: 1,
                    enableSnmp: false,
                    snmpCommunityString: 'public',
                    snmpTimeoutSec: 1
                },
                scheduled_at: null,
                running: false
            };
            this.showNetworkDiscoveryEdit = true;
        },

        doubleClickHandler: function(networkDiscoveryRequest) {
            if(networkDiscoveryRequest.data.started_at || networkDiscoveryRequest.data.running || networkDiscoveryRequest.data.completed_at) {
                return;
            }
            this.editNetworkDiscoveryRequest(networkDiscoveryRequest.data);
        },

        editNetworkDiscoveryRequest: function(networkDiscoveryRequest) {
            if(networkDiscoveryRequest.started_at || networkDiscoveryRequest.running || networkDiscoveryRequest.completed_at) {
                return;
            }
            this.networkDiscoveryEdit = networkDiscoveryRequest;
            this.showNetworkDiscoveryEdit = true;
        },

        closeEditNetworkDiscoveryRequest: function() {
            this.showNetworkDiscoveryEdit = false;
            this.networkDiscoveryEdit = null;
        },

        saveNetworkDiscoveryRequest: function() {
            TELSA.loading(true);
            let isNew = !this.networkDiscoveryEdit.request_id;
            let route = `${TELSA.apiHost}networkdiscovery/edit`;
            if(isNew) {
                route = `${TELSA.apiHost}networkdiscovery/new`;
            }
            let payload = this.networkDiscoveryEdit;
            payload.scheduled_at = payload.scheduleRun ? TELSA.moment(payload.scheduled_at).format('YYYY-MM-DD HH:mm:ss') : null;
            return this.$http.post(route, {args: payload}).then(response => {
                let results = response.body;
                this.closeEditNetworkDiscoveryRequest();
                this.getNetworkDiscoveryRequestList();
            });
        },

        deleteNetworkDiscoveryRequestClick: function(networkDiscoveryRequest) {
            let message = `Are you sure you want to delete this Network Discovey Request?`;
            if(networkDiscoveryRequest.running) {
                message = `Are you sure you want to delete this Network Discovey Request? Doing so will kill the current running discovery process.`;
            }
            this.$store.commit('showConfirmModal', {
                title: 'Are you sure?',
                message: message,
                type: 'delete',
                confirmAction: () => { this.deleteNetworkDiscoveryReques(networkDiscoveryRequest); }
            });
        },
        deleteNetworkDiscoveryReques(networkDiscoveryRequest) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}networkdiscovery/delete`;
            return this.$http.post(route, {args: {request_id: networkDiscoveryRequest.request_id}}).then(response => {
                this.getNetworkDiscoveryRequestList();
            });
        },

        viewNetworkDiscoveryRequestResults: function(networkDiscoveryRequest) {
            this.selectedNetworkDiscovery = networkDiscoveryRequest;
            this.windowPage = 1;
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.networkDiscoveryRequests;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridApi = self.gridOptions.api;
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.columnApi.autoSizeColumns();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'pingTargets');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.getRowStyle = function(params) {
                if(params.data.started_at && params.data.running == false && params.data.result_text.startsWith('ERROR')) {
                    return {background: '#ff5252', color: '#000000'};
                }
                else if(params.data.started_at && params.data.running == false && params.data.completed_at && !params.data.result_text.startsWith('ERROR')) {
                    return {background: '#00E676', color: '#000000'};
                }
            }

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 120, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;

                            let editAllowed = true;
                            let deleteAllowed = true;
                            let resultsAllowed = false;
                            if(params.data.started_at || params.data.running || params.data.completed_at) {
                                editAllowed = false;
                                resultsAllowed = true;
                            }
                            if(params.data.running) {
                                //deleteAllowed = false;
                            }

                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle network-discovery-action" style="cursor: ${self.lockSave || !editAllowed ? 'default' : 'pointer'}; color: ${self.lockSave || !editAllowed ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle network-discovery-action" style="cursor: ${self.lockSave || !deleteAllowed ? 'default' : 'pointer'}; color: ${self.lockSave || !deleteAllowed ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />
                                <span class="mdi mdi-arrow-right-bold-circle network-discovery-action" style="cursor: ${self.lockSave || !resultsAllowed ? 'default' : 'pointer'}; color: ${self.lockSave || !resultsAllowed ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);
                            this.resultsButtonHandler = this.resultsButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.network-discovery-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.network-discovery-action')[1];
                            this.resultsButton = this.eGui.querySelectorAll('.network-discovery-action')[2];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                            this.resultsButton.addEventListener('click', this.resultsButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        resultsButtonHandler(event) {
                            event.stopPropagation();
                            this.params.resultsFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            if(!self.lockSave) {
                                this.editNetworkDiscoveryRequest(params.data);
                            }
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deleteNetworkDiscoveryRequestClick(params.data);
                            }
                        },
                        resultsFunction: (params) => {
                            if(!self.lockSave) {
                                this.viewNetworkDiscoveryRequestResults(params.data);
                            }
                        },
                    }
                },
                {
                    headerName: 'Created By', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'user_username'
                },
                { 
                    headerName: 'Created At', 
                    width: 150, filter: 'agDateColumnFilter', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'created_at'
                },
                { 
                    headerName: 'Scheduled At', 
                    width: 150, filter: 'agDateColumnFilter', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'scheduled_at'
                },
                { 
                    headerName: 'Network', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'network'
                },
                { 
                    headerName: 'Running', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'running',
                    cellRenderer: function(params) {
                        let color = 'rgb(196, 33, 17)'; // TS red
                        //let color = 'rgb(33,150,243)'; // Primary
                        if(params.data.running) {
                            return `<div data-v-18e04e5c="" role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear v-progress-linear--striped v-progress-linear--visible theme--dark" style="height: 6px; margin-top: 8px;"><div class="v-progress-linear__background" style="opacity: 0.3; left: 0%; width: 100%; background-color: ${color}; border-color: ${color};"></div><div class="v-progress-linear__buffer"></div><div class="v-progress-linear__indeterminate v-progress-linear__indeterminate--active"><div class="v-progress-linear__indeterminate long" style="background-color: ${color}; border-color: ${color};"></div><div class="v-progress-linear__indeterminate short" style="background-color: ${color}; border-color: ${color};"></div></div></div>`
                        }
                        else {
                            return `<span>NO</span>`;
                        }
                    }
                },
                { 
                    headerName: 'Ping Scan', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'ping_scan',
                    valueGetter: function(params) {
                        return params.data.scan_options.enablePing ? 'YES' : 'NO';
                    }
                },
                { 
                    headerName: 'SNMP Scan', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'snmp_scan',
                    valueGetter: function(params) {
                        return params.data.scan_options.enableSnmp ? 'YES' : 'NO';
                    }
                },
                { 
                    headerName: 'Started At', 
                    width: 150, filter: 'agDateColumnFilter', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'started_at'
                },
                { 
                    headerName: 'Completed At', 
                    width: 150, filter: 'agDateColumnFilter', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'completed_at'
                },
                { 
                    headerName: 'Results', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    field: 'result_text'
                },
            ];
            return columnDefs;
        },

        addDevicesClick: async function(type, selectedDevices) {
            let selectedDevicesClone = JSON.parse(JSON.stringify(selectedDevices));

            if(type == 'ping') {
                let lockName = `edit_ping`;
                let lockOwner = await this.$store.dispatch('getLock', lockName);
                TELSA.loading(false);
                if(lockOwner) {
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The Ping Targets are already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                    return;
                }

                selectedDevicesClone.forEach(d => {
                    d.add_ping_name = d.hostname || d.ip_address;
                    d.add_ping_addr = d.ip_address;
                    d.add_ping_ping_location = '';
                    d.disabled = this.existingDevices.existing_ping_targets.some(ed => ed.ping_addr == d.ip_address);
                    d.formValid = true;
                });
            }

            else if(type == 'snmp') {
                let lockName = `edit_tsini`;
                let lockOwner = await this.$store.dispatch('getLock', lockName);
                TELSA.loading(false);
                if(lockOwner) {
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The SNMP page is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                    return;
                }

                selectedDevicesClone.forEach(d => {
                    d.addKey = d.ip_address;
                    d.addVersion = '2c';
                    d.addCommunity = this.selectedNetworkDiscovery.scan_options.snmpCommunityString;
                    d.addHoursValue = 0;
                    d.addMinValue = 15;
                    d.addSecValue = 0;
                    d.addPmGroups = [];
                    for(let pmGroup of this.selectedNetworkDiscovery.scan_options.pm_groups) {
                        if(d.snmp_data && d.snmp_data[pmGroup]) {
                            d.addPmGroups.push(pmGroup);
                        }
                    }
                    d.disabled = this.existingDevices.existing_snmp_devices.some(ed => ed.key == d.ip_address);
                    d.formValid = false;
                });
            }
            
            this.addDeviceType = type;
            this.selectedAddDevices = selectedDevicesClone;
            this.showAddDevices = true;
        },
        addDevices: function() {
            if(this.addDeviceType == 'ping') {
                let promises = [];
                TELSA.loading(true);
                let route = (TELSA.apiHost + "pingtargets/add");
                for(let d of this.selectedAddDevices) {
                    if(!d.disabled) {
                        let pt = {
                            ping_id: 0,
                            ping_addr: d.ip_address,
                            ping_name: d.add_ping_name,
                            ping_location: d.add_ping_ping_location
                        };
                        promises.push(this.$http.post(route, {args: {lock: this.$store.state.lock, target: pt}}));
                    }
                }
                Promise.all(promises).then(r => {
                    this.$store.dispatch('handleRemoveLocks', 'ALL');
                    this.getExistingDevices().then(rr => {
                        this.showAddDevices = false;
                        this.refreshResults++;
                    });
                });
            }
            else if(this.addDeviceType == 'snmp') {
                let snmpDevicesList = [];
                TELSA.loading(true);
                let route = (TELSA.apiHost + "snmp/collect");
                return this.$http.get(route).then(response => {
                    let result = response.body;
                    snmpDevicesList = result.pm_collect_snmp_list;
                    // add new devices
                    for(let d of this.selectedAddDevices) {
                        let frequencySeconds = ((parseInt(d.addHoursValue) * 3600) + (parseInt(d.addMinValue) * 60) + parseInt(d.addSecValue));
                        snmpDevicesList.push({
                            section: 'pm_collect_snmp', key: d.ip_address, version: d.addVersion, community: d.addCommunity, frequency: frequencySeconds, pm_groups: d.addPmGroups
                        });
                    }
                    // format all devices
                    for(let d of snmpDevicesList) {
                        d.value = JSON.stringify({version: d.version, community: d.community, frequency: d.frequency, pm_groups: d.pm_groups});
                        d.comment = d.comment || "";
                    }
                    return this.$http.post(route, {args: {lock: this.$store.state.lock, pmCollectList: snmpDevicesList}}).then(response => {
                        let result = response.body;
                        this.$store.dispatch('handleRemoveLocks', 'ALL');
                        this.getExistingDevices().then(rr => {
                            this.showAddDevices = false;
                            this.refreshResults++;
                        });
                    }); 
                });
            }
        },

        cancelAddDevices: function() {
            this.showAddDevices = false;
            this.$store.dispatch('handleRemoveLocks', 'ALL');
        },

        processUpdate: function(update) {
            let refreshRowData = false;

            if(!(update.request_id && update.type)) {
                console.warn('Malformed Network Discovery message: ', update);
                return
            }
            let networkDiscoveryRequest = this.networkDiscoveryRequests.find(r => r.request_id == update.request_id);
            if(!networkDiscoveryRequest) {
                console.warn('No matching Network Discovery Request found: ', update);
                return;
            }
            if(update.type == 'state') {
                Object.keys(update.data).forEach(key => {
                    if(key in networkDiscoveryRequest) {
                        networkDiscoveryRequest[key] = update.data[key];
                    }
                });
                refreshRowData = true;
            }
            else if(update.type == 'note') {
                networkDiscoveryRequest.run_notes += update.data;
            }
            else if(update.type == 'host') {
                if(update.data.snmp_data && typeof update.data.snmp_data === 'string') {
                    update.data.snmp_data = JSON.parse(update.data.snmp_data);
                }
                let existingResultIndex = networkDiscoveryRequest.results.findIndex(r => r.ip_address == update.data.ip_address);
                if(existingResultIndex > -1) {
                    networkDiscoveryRequest.results[existingResultIndex] = update.data;
                }
                else {
                    networkDiscoveryRequest.results.push(update.data);
                }
            }
            if(refreshRowData) {
                this.gridApi.setRowData(this.networkDiscoveryRequests);
            }
        }
    },

    mounted() {
        if(!this.hasLicense || !this.isCustomerAdmin) {
            return;
        }
        this.getExistingDevices();
        this.getNetworkDiscoveryRequestList();

        this.$store.commit('showConfirmModal', {
            title: 'Disclaimer',
            message: `By using this network discovery tool, you acknowledge that scanning networks may trigger intrusion detection systems (IDS) and other security measures. 
                      You are responsible for ensuring you have permission to scan the specified network and that you understand the potential implications of your actions. 
                      If you are unsure, please consult with your IT department before proceeding.`,
            type: 'warning',
            hideCancel: true,
            confirmAction: function(){}
        });
    },

    
    sockets: {
        NETWORK_DISCOVERY: function(data) {
            this.processUpdate(data);
        }
    },

  
};
</script>

<style scoped>

    #ag-grid-container {
        height: calc(100vh - 126px);
    }

</style>
